/** A URL do MCP que o consultor cola no `claude mcp add`.
 *
 * **Derivada da origem, não assada no build.** O MCP é servido no MESMO domínio
 * do app, em `/mcp` (ver `frontend/Caddyfile`), então a origem já é a resposta.
 *
 * Assar no bundle era o defeito: o valor entrava no build e o bundle é imutável,
 * então a imagem construída para um ambiente entregava ao consultor de outro um
 * comando apontando para o lugar errado. Derivar em runtime deixa **uma** imagem
 * servir todos os ambientes publicados.
 *
 * `localhost` e `127.0.0.1` caem no default direto da porta do serviço, porque aí
 * o app roda no dev server sem o Caddy na frente e nada proxia `/mcp`. Um host
 * como `mygrow.localhost` NÃO cai nesse caso, de propósito: ele é servido pelo
 * Caddy local e proxia igual ao publicado.
 *
 * `VITE_MCP_URL` continua valendo como override explícito.
 */
export function resolveMcpUrl(): string {
  const override = import.meta.env.VITE_MCP_URL;
  if (override) return override;

  const host = typeof window !== "undefined" ? window.location.hostname : "";
  if (host === "localhost" || host === "127.0.0.1") {
    return "http://localhost:8003/mcp";
  }
  return `${window.location.origin}/mcp`;
}
